import { useTranslation } from 'react-i18next'

interface Testimonial {
  textKey: string
  authorKey: string
  avatar: string
}

const testimonials: Testimonial[] = [
  {
    textKey: 'landing.testimonials.items.daniel.text',
    authorKey: 'landing.testimonials.items.daniel.author',
    avatar: 'Д',
  },
  {
    textKey: 'landing.testimonials.items.maria.text',
    authorKey: 'landing.testimonials.items.maria.author',
    avatar: 'М',
  },
  {
    textKey: 'landing.testimonials.items.alexander.text',
    authorKey: 'landing.testimonials.items.alexander.author',
    avatar: 'А',
  },
]

export function Testimonials() {
  const { t } = useTranslation()

  return (
    <section className="testimonials">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('landing.testimonials.title')}</h2>
          <p className="section-subtitle">{t('landing.testimonials.subtitle')}</p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <p className="testimonial-text">{t(testimonial.textKey)}</p>
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.avatar}</div>
                <div className="author-info">
                  <h4>{t(testimonial.authorKey)}</h4>
                  <p>{t('landing.testimonials.role')}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
